import { finalCta, brand } from "../content/site";
import { Button, Container, Reveal } from "./ui";

function scrollTo(e, href) {
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
}

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-navy py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_50%,rgba(255,74,0,0.25),transparent)]" />
        <div className="absolute top-0 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-primary/15 blur-[130px]" />
      </div>

      <Container className="relative">
        <Reveal className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <h2 className="text-4xl leading-[1.05] font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            {finalCta.headlineTop}
            <br />
            <span className="text-primary">{finalCta.headlineBottom}</span>
          </h2>
          <p className="mt-6 text-lg text-white/60 sm:text-xl">{finalCta.subheadline}</p>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row">
            <Button href="#waitlist" onClick={(e) => scrollTo(e, "#waitlist")} size="lg">
              {finalCta.cta1}
            </Button>
            <Button
              href="#owner-waitlist"
              onClick={(e) => scrollTo(e, "#owner-waitlist")}
              variant="outline-white"
              size="lg"
            >
              {finalCta.cta2}
            </Button>
          </div>

          <p className="mt-10 text-sm font-bold tracking-[0.25em] text-primary/90 uppercase">
            {brand.tagline}
          </p>
        </Reveal>
      </Container>
    </section>
  );
}
